import { HttpStatusCode } from '@angular/common/http';
import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';
import { IApiResponseError } from '@app/api/interfaces/common/api-response-error.interface';

export class HttpError implements IApiResponseError<BaseErrorStatus | string> {
  public readonly statusCode?: HttpStatusCode;
  public readonly statusDescription?: string;

  public readonly message: string;
  /**
   * @description StatusKey
   */
  public readonly status: string;
  public readonly data: string;

  constructor(message: string, data: string, status: string, statusDescription?: string, statusCode?: HttpStatusCode) {
    this.message = message;
    this.status = status;
    this.data = data;

    if (statusDescription) {
      this.statusDescription = statusDescription;
    }
    if (statusCode) {
      this.statusCode = statusCode;
    }
  }
}
